import { render } from "./ProductSearchComponent.vue?vue&type=template&id=8729615e"
import script from "./ProductSearchComponent.vue?vue&type=script&lang=js"
export * from "./ProductSearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__